/* Comic Legion V1.9: reviews carousel on phones shows one review at a time and moves on by itself every 5 seconds
   (back to the first after the last). It waits while it's off screen, and pauses for 8 seconds after a swipe or tap. */
(function () {
  var phone = window.matchMedia('(max-width: 640px)');
  function setup(root) {
    var track = root && root.querySelector('[data-cl-reviews-track]');
    if (!track || track.dataset.clAuto) return;
    track.dataset.clAuto = '1';
    var touched = 0;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { touched = Date.now(); }, { passive: true });
    });
    setInterval(function () {
      if (!phone.matches || document.hidden || Date.now() - touched < 8000) return;
      var box = track.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      var w = track.clientWidth, end = track.scrollWidth - w - 2;
      track.scrollTo({ left: track.scrollLeft >= end ? 0 : track.scrollLeft + w, behavior: 'smooth' });
    }, 5000);
  }
  function all() { document.querySelectorAll('[data-section-type="cl-reviews"]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
